import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { FilterService } from 'features/filters/service/service'

export { fetchFilterOptionsV2 } from 'features/filters/service/fetch-filter-options-v2'
export {
  FilterService,
  filterPresetsQueryKey,
} from 'features/filters/service/service'

export function useFilterService(): FilterService {
  const client = useApiClient()
  return useMemo(() => new FilterService(client), [client])
}
